import axios, { type AxiosHeaders, type AxiosInstance } from 'axios';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN, HEADER_DEFAULT, TIMEOUT } from 'src/types/apiTypes';

const defaultConfig = (headers: AxiosHeaders) => {
    const newHeaders = { ...headers };
    return {
        baseURL: sessionStorage.getItem('API_BASE_URL') || '',
        headers: { ...newHeaders, source: 'scene_tile' },
        timeout: TIMEOUT
    };
};

const configInterceptors = (axiosClient: AxiosInstance) => {
    // Add a request interceptor
    axiosClient.interceptors.request.use(
        function (config) {
            const token = Cookies.get(ACCESS_TOKEN);
            config.headers['Access-Control-Allow-Origin'] = '*'; // Incorrect
            config.headers['Access-Control-Allow-Headers'] = '*'; // Incorrect

            config.headers['Accept-Language'] = '*';
            config.headers['Content-Type'] = 'application/json';
            config.headers.Authorization = `Bearer ${token}`;

            return config;
        },
        function (error) {
            console.log('axiosClient.interceptors.request: Request error:', error);
            return Promise.reject(new Error(error));
        }
    );
    // axiosClient.interceptors.response.use(
    //     function (response) {
    //         console.log('API Response:', response); // Debug log for API response
    //         return response;
    //     },
    //     function (error) {
    //         console.log('API Response Error:', error); // Debug log for API response error
    //         return Promise.reject(error);
    //     }
    // );
    axiosClient.interceptors.response.use(
        function onFulfilled(response) {
            console.log('axiosClient.interceptors: API Response:', response); // Debug log for API response
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            return response;
        },
        function onRejected(error) {
            console.log('axiosClient.interceptors: API Response Error:', error); // Debug log for API response error
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            return Promise.reject(error);
        }
    );

    return axiosClient;
};

// Add AbortController support
export const createCancelableRequest = () => {
    const controller = new AbortController();
    if (!sessionStorage.getItem('API_BASE_URL')) {
        console.error('API_BASE_URL is not set in sessionStorage');
    }
    const axiosInstance = axios.create({
        ...defaultConfig(HEADER_DEFAULT),
        signal: controller.signal // Attach the AbortController signal
    });

    const cancelRequest = () => {
        controller.abort(); // Cancel the request
    };

    return { axiosInstance: configInterceptors(axiosInstance), cancelRequest };
};
